<div
  class="dynamic-field form-input"
  [ngClass]="[config.name + '-container', isRequired ? 'dynamic-field--required' : '']"
  [formGroup]="group"
>
  <cwc-input-date
    [label]="config.label | translate"
    [formControl]="fieldControl"
    [disabledDates]="disabledDates"
    [minDate]="min"
    [attr.data-test]="config?.dataTId"
    [attr.data-tid]="config?.dataTId"
    [attr.data-name]="config?.name"
    [status]="controlStatus$ | async"
    [statusMessage]="controlStatusMessage$ | async | translate: statusMessageParameter"
    [maxDate]="max"
    [disabled]="disabled"
    [returnFormat]="'date'"
    [firstDayOfWeek]="config.startWeekWith"
    [hideOutsideDays]="config.hideOutsideDays"
    [labelCancel]="config.labelCancel | translate"
    [placeholder]="config.placeholder | translate"
    [required]="isRequired"
    >
  </cwc-input-date>
</div>
